import axios from 'axios';
import { useEffect, useState } from 'react'
import Box from 'elements/Box';
import { Button, CircularProgress, IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Link } from 'react-router-dom';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { ProjectConfig } from 'Global';
import AlertDialog from 'elements/AlertDialog';


const OracionesCategoryList = () => {

  interface List {
    oraciones_category_id: number;
    title: string;
  }

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState<List[]>([]);
  const [total_pages, setTotalPages] = useState(0);

  const queryParams = new URLSearchParams(window.location.search);
  const currentPage = parseInt(localStorage.getItem('page') || "1");

  const [page, setPage] = useState(currentPage);
  const [numItem, setNumItem] = useState(10);
  const [refreshList, setRefreshList] = useState(0);


  /*=========================================================
  LOAD LIST            
  =========================================================*/

  useEffect(() => {

    setLoading(false)
    axios.get(ProjectConfig.api_url,
      {
        params: {
          request: 'oraciones_category_list',
          page: page,
          numItem:numItem
        }
      })
      .then((response) => {
        console.log("Response:", response.data); 
        if (response.data && response.data.list) {
          setList(response.data.list)
          setTotalPages(response.data.total_pages)
        } else {
          console.error("Invalid API response:", response.data);
          setList([])
          setTotalPages(0)
        }
        setLoading(true)

      })
      .catch((err) => {
        console.log("API Error:", err);
        setList([])
        setLoading(true)
      })
    localStorage.setItem('page', page.toString())

  }, [page, refreshList, numItem])
  /*=========================================================*/




  /*=========================================================
  DELETE ITEM
  =========================================================*/

  const handleDelete = (id: number) => {
    setActiveItem(id)
    setOpenAlert(true)
  }


  const deleteItem = () => {
    axios.post(ProjectConfig.api_url, null,
      {
        params: {
          request: 'delete_oraciones_category',
          id: activeItem,
        }
      })

      .then((response) => {
        console.log(response.data);
        setRefreshList(refreshList + 1)

      })
      .catch((err) => {
        console.log(err.data);
      })
      .then(() => {
        setOpenAlert(false)
      })
  }
  /*=========================================================*/

  const [openAlert, setOpenAlert] = useState(false);
  const [activeItem, setActiveItem] = useState<any>(null);

  // Función para manejar el cambio en el select
  const handleCantidadChange = (event:any) => {
    const newValue = event.target.value;
    setNumItem(newValue); 
    setPage(1);
  };
  



  return (
    <div id='ProductList'>

      <div className='buttons_top'>
        <Button component={Link} to="add" variant="contained">
          Nueva Categoria
        </Button>
      </div>
      
      <div id="task_list_container" className="flex_container">

        <Box id='user_list' title="Oraciones" subtitle="Categorías"  >
          {!loading && <div id='loader'><CircularProgress /></div>}
          <TableContainer>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell>Categoría</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list && list.length > 0 ? list.map((list_item, i) => (
                  <TableRow
                    key={i}
                    hover
                    role="checkbox"
                  >
                    <TableCell onClick={() => { window.location.href = `/admin/oraciones/categorias/edit/${list_item.oraciones_category_id}` }} >
                      {list_item.title}
                    </TableCell>

                    <TableCell>
                      <IconButton aria-label="delete" color="primary" onClick={() => handleDelete(list_item.oraciones_category_id)}>
                        <DeleteOutlineOutlinedIcon />
                      </IconButton>

                      <Button component={Link} to={`/admin/oraciones/${list_item.oraciones_category_id}`} variant="contained">
                        Ver Oraciones
                      </Button>
                    </TableCell>

                  </TableRow>
                )) : (
                  <TableRow>
                    <TableCell colSpan={2} align="center">No hay categorías disponibles</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Pagination count={total_pages} page={page} onChange={(event, value) => {
            setPage(value)
          }
          }
            color="primary"
            style={{ "marginTop": "20px", "alignSelf": "center" }}
          />
        </Box>

      </div>

      <AlertDialog
        open={openAlert}
        setOpen={setOpenAlert}
        subtitle="¿Esta acción también borrará los elementos de esta categoría. ¿Desea continuar?"
        send={deleteItem}
      />
    </div>
  );
};



export default OracionesCategoryList;
